import {
    Component,
    computed,
    effect,
    HostListener,
    Input,
    OnInit,
    signal,
    ViewChild,
    WritableSignal
} from '@angular/core';
import {EstadoTramiteEnum, TramiteItem, TramiteTipoRequisitoItem} from '../interfaces/tramites.interface';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {TramiteService} from '../../services/tramite.service';
import {catchError, debounceTime, distinctUntilChanged, map, throwError} from 'rxjs';
import {switchMap, tap} from "rxjs/operators";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {CatalogoInterface} from "../../../interfaces/proyecto.interface";
import {TarifarioInterface} from "../../../interfaces/pagos.interface";
import {ProyectoService} from "../../../proyectos/services/proyecto.service";
import {
    AreaChanged,
    AreasInterfaces,
    DetalleConstruccionInterface,
    LoteInterface,
    LotesInterface,
    ProfesionalesTablaInterface,
    TipoAreaEnum, UnidadesHabitacionalesInterface
} from "../interfaces/formulario.interfaces";
import {MessageService} from "primeng/api";
import {SdetTramiteService} from "../../services/sdet-tramite.service";
import {PersonasService} from "../../../../shared/services/personas-service";
import {defaultProyectoPerfil, ProyectoPerfil} from "../../../interfaces/perfil.interface";
import {isAlphaNumericValidEvent} from "../../../../shared/services/utils-service";
import {Location} from "@angular/common";
import Swal from "sweetalert2";
import {CatalogoService} from "../../../../shared/services/catalogo-service";
import {Table} from "primeng/table";
import {TipoAutorizaciones} from "../../../../shared/interfaces/shared-interface";
import {FormularioAService} from "../../services/formulario-a.service";

@Component({
    selector: 'app-formulario-b',
    templateUrl: './formulario-b.component.html',
    providers: [MessageService],
    styleUrls: ['./formulario-b.component.scss']
})
export class FormularioBComponent implements OnInit  {
    selectGeneralidades: boolean = false
    idTramite: string | null = null
    idTipoProyecto: number = 1
    cantidadUnidades: number | null = null;
    camposCompletos: boolean = false
    tipoArea: CatalogoInterface[] = []
    listaEntorno: CatalogoInterface[] = []
    tarifa: number = 0
    nombreTramite: string = ''
    selected: TramiteItem = null!
    esConstruccion: WritableSignal<boolean> = signal(false)
    tipoLotes: CatalogoInterface[] = []
    datosLotes: LoteInterface[] = [];
    tipoLoteSeleccionado: CatalogoInterface | null = null
    tipoInmueble: CatalogoInterface[] = []
    tipoInmuebleSeleccionado: CatalogoInterface | null = null
    errorInmueble: boolean = false;
    errorNiveles: boolean = false;
    errorCantidad: boolean = false;
    errorTipoInmubleInput: boolean = false;
    niveles: CatalogoInterface[] = []
    datosDetallesConstruccion: DetalleConstruccionInterface[] = []
    nivelSeleccionado: CatalogoInterface | null = null
    calculoAreaConstruccion: boolean = false;
    tipoInmuebleInput: string | null = null
    showProfesionales: boolean = false
    profesionales: CatalogoInterface[] = []
    profesionalSeleccionado: CatalogoInterface | null = null
    personaEncontradaTemp: ProyectoPerfil = null!
    errorLotes: boolean = false
    errorProfesional: boolean = false
    tramiteCompleto: boolean = true
    cantidadLotes: number = 0
    limpiarBusquedaPersona: boolean = false
    datosProfesionales: ProfesionalesTablaInterface[] = [];
    requisitoTipoTramite: TramiteTipoRequisitoItem[] = [];
    idProyecto: string | null = null
    condicion: boolean = true;
    botonAgregarProfesional: boolean = true;
    datosCalcular: TarifarioInterface[] = []
    isLoading = signal(false);
    // areaActiva = signal<number>(0);
    formularioActual: 'forma' | 'formb' | 'formc' = 'formb';
    @Input() _showLoader: boolean = false
    @ViewChild('dtProfesionales') dtProfesionales!: Table;
    @ViewChild('dtDetalleConstruccion') dtDetalleConstruccion!: Table;
    @ViewChild('dtLotes') dtLotes!: Table;
    prjId$ = this.route.params.pipe(map((params) => params['idProyecto']));
    protected readonly TipoAutorizaciones = TipoAutorizaciones;
    constructor(public router: Router, private route: ActivatedRoute, private proyectoService: ProyectoService,
                private sdetTramiteService: SdetTramiteService, private catalogoService: CatalogoService,
                protected tramiteService: TramiteService, private loginServices: LoginServices,
                private messageService: MessageService, public personasService: PersonasService, private location: Location,
                private formularioAService:FormularioAService) {
        this.personaEncontradaTemp = defaultProyectoPerfil();
    }

    ngOnInit(): void {
        this.datosProfesionales=[ ];
        this.preFetchProyectoId()
        if (this.tramiteService.idProyecto()) {
            this.proyectoService.getGeneralesProyecto(this.tramiteService.idProyecto()!)
                .pipe(
                    catchError(error => {
                        return throwError(error)
                    })
                )
                .subscribe(
                    resp => {
                        if (resp.status == 200) {
                            this.tramiteService.proyectoAsignado.set(resp.body!)
                            if (this.tramiteService.proyectoAsignado()[0].idTipoProyecto != 4) {
                                this.esConstruccion.set(false)
                            } else {
                                this.esConstruccion.set(true)
                            }
                        }
                        if (!this.esConstruccion()) {
                            this.catalogoService.getCatalogo('tipo_lote')
                                .subscribe(
                                    resp => {
                                        this.tipoLotes = resp
                                        this.tipoLotes = this.tipoLotes.filter(valor => valor.id !== '6')
                                    }
                                )
                        } else {
                            this.catalogoService.getCatalogo('tipo_inmueble')
                                .subscribe(
                                    resp => {
                                        this.filterTipoInmueble(resp);
                                        this.catalogoService.getCatalogo('nivel')
                                            .subscribe(
                                                resp => {
                                                    this.niveles = resp
                                                }
                                            )
                                    }
                                )
                        }
                    }
                )
            this.getInfoAreaProyecto(this.tramiteService.idProyecto()!, this.calculoAreaConstruccion, "tipoareas");
        }
        this.route.paramMap.subscribe((params: ParamMap) => {
            if (params.get('idTramite') != null) {
                this.idTramite = +params.get('idTramite')! ? params.get('idTramite') : null
                if (this.idTramite != null) {
                    this.sdetTramiteService.obtenerSdetItem(this.tramiteService.idProyecto()!, this.idTramite)
                        .subscribe(
                            resp => {
                                this.selected = resp.body!
                            }
                        )
                    this.tramiteService.getTramite(this.idTramite)
                        .subscribe(
                            resp => {
                                this.nombreTramite = resp.body?.nombreTramite!
                            }
                        )
                }
            }
            if (this.idTramite == '10') {//TODO: Aplicar mejora este el id del tramite permiso de construccion el cual necesita area de construccion para el tarifario
                this.calculoAreaConstruccion = true
            } else {
                this.calculoAreaConstruccion = false
            }
            if (params.get('idProyecto') != null) {
                this.idProyecto = +params.get('idProyecto')! ? params.get('idProyecto') : null
                if (this.idProyecto != null) {
                    this.tramiteService.getRequisitosPorParametros(this.idTramite!, this.idProyecto, this.requisitoTipoTramite);
                }
            }
            this.catalogoService.getCatalogo('tipo_area')
                .subscribe(
                    resp => {
                        this.tipoArea = resp
                    }
                )
            this.catalogoService.getCatalogo('entorno')
                .subscribe(
                    resp => {
                        this.listaEntorno = resp
                    }
                )
        });
    }

    areaActiva = computed(() => this.esConstruccion() ? this.tramiteService.areaConstruccionSignal() : this.tramiteService.areaTotalSignal());

    setAreaActiva(area: number){
        if(area !== null && area > 0){
            if(this.esConstruccion()){
                this.tramiteService.areaConstruccionSignal.set(area);
            }else{
                this.tramiteService.areaTotalSignal.set(area);
            }
        }
    }

    //Metodo para activar el formulario condicional
    esFormularioActivo(tipo: string): boolean {
        return this.formularioActual === tipo;
    }

    //Validacion para activar los inputs de las areas, si tienen o no requieren pago o no tienen un tramite asignado o vienen vacios
    isReadOnly = computed(() => {
        return this.selected.idEstadoTramite === EstadoTramiteEnum.FormularioCompleto || this.selected.idEstadoTramite === EstadoTramiteEnum.PagoRealizado;
    });

    formCompletado = computed(() => {
        if(this.selected.idEstadoTramite !== null || this.selected.idEstadoTramite !== undefined){
            return this.selected.idEstadoTramite === EstadoTramiteEnum.FormularioCompleto;
        }else{
            return this.selected.idEstadoTramite === EstadoTramiteEnum.FormularioCompleto;
        }
    })

    private preFetchProyectoId() {
        console.log(`preFetchProyectoId`)
        this.prjId$.subscribe((id) => {
            if (id) {//load everything prj sequence.
                this.tramiteService.idProyecto.set(id)
            }
        });
        console.log(`params -> this.tramite.idProyecto  -> ${this.tramiteService.idProyecto()}`)
    }
    /**Metodo obtiene la informacion de areas y de la area total del proyecto previamente registrado en el FU.*
     */
    getInfoAreaProyecto(idProyecto: string, bandera: boolean, info: string | null) {
        if (info == "tipoareas" && idProyecto != null) {
            this.tramiteService.getObtenerTipoAreas(idProyecto!, []).subscribe(
                resp => {
                    this.tramiteService.tiposAreas.set(resp);
                    this.tramiteService.areaConstruccionSignal.set(this.getAreaByTipo(TipoAreaEnum.Areaconstruccion!));//visualizar areaconstruccion del proyecto
                    this.tramiteService.areaTotalSignal.set(this.getAreaByTipo(TipoAreaEnum.Areaproyecto!));//visualizar area del proyecto
                }
            );
        }
    }

    obtenerProyecto() {
        this.selectGeneralidades = !this.selectGeneralidades
    }

    filterTipoInmueble(resp: CatalogoInterface[]) {
        if (resp.length == 0) {
            return [];
        }
        if (this.tramiteService.proyectoAsignado()[0].entorno == 'Habitacional') {
            this.tipoInmueble = resp.filter(item => item.id !== '1');
        } else if (this.tramiteService.proyectoAsignado()[0].entorno == 'No Habitacional') {
            this.tipoInmueble = resp.filter(item => item.id !== '2' && item.id !== '3');
        } else {
            this.tipoInmueble = resp
        }
        return this.tipoInmueble;
    }

    onChangeCalcularTarifa() {
        // let areaTotal=this.getAreaByTipo(TipoAreaEnum.Areaproyecto!)
        let areaIn = this.areaActiva();
        if (areaIn != null && areaIn != 0) {
            this._showLoader = true;
            this.calcularTarifa().pipe(
                debounceTime(200), // Debounce for 200 milliseconds
                distinctUntilChanged(), // Only proceed if the query has changed
                catchError(error => {
                    let text = error.mensaje;
                    if (error.error && error.error.mensaje) {
                        text = error.error.mensaje; // Extract the custom message
                    } else if (error.message) {
                        text = error.message; // Fallback to the general error message
                    }
                    if (text.includes('api')) {
                        text = 'Ocurrió un error al procesar, intente mas tarde'
                    }
                    this.tramiteService.textTarifa='Calculo de tarifa no disponible en este momento.';
                    this._showLoader = false;
                    return throwError(error.statusText);
                })
            ).subscribe({
                next: (result) => {
                    if (result && result.body) {
                        let respuesta: TarifarioInterface[] | null = result.body
                        for (let i of respuesta!) {
                            if (i.total) {
                                this.tramiteService.textTarifa='';
                                this.tarifa = parseFloat(i.total.toFixed(2))!
                            } else {
                                this.tarifa = 0
                            }
                            console.log(`this.tarifa = ${this.tarifa}`)
                            console.log(`institucion =${this.loginServices.session()?.perfil.idInstitucion}`)
                            this._showLoader = false;
                        }
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
        }
    }

    calcularTarifa() {
        console.log(`calcularTarifa()`)
        if (this.esConstruccion()) {
            let areaConstruccion=this.getAreaByTipo(TipoAreaEnum.Areaconstruccion!)
            if (areaConstruccion != 0 && areaConstruccion != null) {
                console.log('Area construccion --------->:', areaConstruccion);
                this.tramiteCompleto = true
                this.datosCalcular = [
                    {
                        idEntorno: this.tramiteService.proyectoAsignado()[0].idEntorno!,
                        idTramite: parseInt(this.idTramite!, 10),
                        idTipoArea: this.tramiteService.tiposAreas().find(area => area.idTipoArea === TipoAreaEnum.Areaconstruccion)?.idTipoArea!,
                        area: areaConstruccion,
                        idProyecto: this.tramiteService.idProyecto(),
                        creadoPor: this.loginServices.session()?.perfil.usuario,
                        idInstitucion: this.loginServices.session()?.perfil.idInstitucion,
                        idSolicitud: this.tramiteService.proyectoAsignado()[0].idSolicitud!
                    }
                ]
            } else {
                //TODO:SE AGREGO ESTE FRAGMENTO DE CODIGO PARA FUNCIONALIDAD
                // AQUELLOS PROYECTOS QUE NO SON DE TIPO CONTRUCCION NO POSEEN AREA DE CONSTRUCCION Y EL TARIFARIO NECESEITABA AREA DE CONSTRUCCION
                // LA DB CUENTA CON TARIFAIO PARA ESTE CALCULO
                this.datosCalcular = [
                    {
                        idEntorno: this.tramiteService.proyectoAsignado()[0].idEntorno!,
                        idTramite: parseInt(this.idTramite!, 10),
                        idTipoArea:this.tramiteService.tiposAreas().find(area => area.idTipoArea === TipoAreaEnum.Areaproyecto)?.idTipoArea!,
                        area: this.getAreaByTipo(TipoAreaEnum.Areaproyecto!),
                        idProyecto: this.tramiteService.idProyecto(),
                        creadoPor: this.loginServices.session()?.perfil.usuario,
                        idInstitucion: this.loginServices.session()?.perfil.idInstitucion,
                        idSolicitud: this.tramiteService.proyectoAsignado()[0].idSolicitud!
                    }
                ]
                this.tramiteCompleto = false
            }
        } else {
            let areaTotal=this.getAreaByTipo(TipoAreaEnum.Areaproyecto!)
            console.log('Area Total --------->:', areaTotal);
            if (areaTotal != 0 && areaTotal != null) {
                this.tramiteCompleto = true
                this.datosCalcular = [
                    {
                        idEntorno: this.tramiteService.proyectoAsignado()[0].idEntorno!,
                        idTramite: parseInt(this.idTramite!, 10),
                        idTipoArea:this.tramiteService.tiposAreas().find(area => area.idTipoArea === TipoAreaEnum.Areaproyecto)?.idTipoArea!,
                        area: areaTotal,
                        idProyecto: this.tramiteService.idProyecto(),
                        creadoPor: this.loginServices.session()?.perfil.usuario,
                        idInstitucion: this.loginServices.session()?.perfil.idInstitucion,
                        idSolicitud: this.tramiteService.proyectoAsignado()[0].idSolicitud!
                    }
                ]
            } else {
                this.tramiteCompleto = false
            }
        }
        return this.tramiteService.calcularTarifa(this.datosCalcular);
    }

    agregarLotes() {
        if (this.cantidadLotes != 0 && this.tipoLoteSeleccionado != null) {
            this.errorLotes = false
            let lote: LoteInterface = {
                cantidadLotes: this.cantidadLotes,
                idTipoLote: parseInt(this.tipoLoteSeleccionado.id!),
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario,
                idProyecto: parseInt(this.tramiteService.idProyecto()!),
                descripcion: this.tipoLoteSeleccionado.descripcion
            }
            this.datosLotes.push(lote)
            this.dtLotes.reset();
            if(this.datosLotes.length > 0){
                this.guardarLotesProyecto(this.datosLotes);
            }
        } else {
            this.errorLotes = true
        }
    }

    agregarDetConstruccion() {
        this.errorInmueble = false;
        this.errorNiveles = false;
        this.errorCantidad = false;
        this.errorTipoInmubleInput = false;
        if (this.tipoInmuebleSeleccionado == null) {
            this.errorInmueble = true;
        }
        if (this.nivelSeleccionado == null) {
            this.errorNiveles = true;
        }
        if (this.cantidadUnidades == null || this.cantidadUnidades <= 0) {
            this.errorCantidad = true;
        }
        if (!this.tipoInmuebleInput) {
            this.errorTipoInmubleInput = true;
        }
        if (!this.errorInmueble && !this.errorNiveles && !this.errorCantidad && this.tipoInmuebleSeleccionado?.id != null && !this.errorTipoInmubleInput) {
            const listaConstruccion: DetalleConstruccionInterface = {
                cantidad: this.cantidadUnidades!,
                idNivel: parseInt(this.nivelSeleccionado?.id!),
                idTipoInmueble: parseInt(this.tipoInmuebleSeleccionado.id!),
                idProyecto: parseInt(this.tramiteService.idProyecto()!),
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario,
                descripcion: this.tipoInmuebleInput,
                idInstitucion: this.loginServices.session()?.perfil.idInstitucion!,
                idTramite: parseInt(this.selected.idTramite!)
            };
            this.datosDetallesConstruccion.push(listaConstruccion);
            this.dtDetalleConstruccion.reset();
            if(this.datosDetallesConstruccion.length > 0){
                this.guardarDetallesContruccion(this.datosDetallesConstruccion);
            }
        }
    }

    agregarProfesionales() {
        if (this.profesionalSeleccionado != null) {
            this.errorProfesional = false
            let perfilProfesional: ProfesionalesTablaInterface = {
                nombre: this.personaEncontradaTemp.personaInfo?.nombres!,
                numero_documento: this.personasService.findDocumentoFirst(this.personaEncontradaTemp.personaInfo?.documentos!)?.documento,
                responsable: this.profesionalSeleccionado!,
                responsableDescripcion: this.profesionalSeleccionado.descripcion,
                idProyecto: parseInt(this.tramiteService.idProyecto()!),
                idProyectoProfesional: parseInt(this.profesionalSeleccionado.id!),
                idProfesional: parseInt(this.personaEncontradaTemp.personaInfo?.idPersona!),
                usuario: this.loginServices.session()?.perfil.usuario
            }
            let existeProfesional = this.datosProfesionales
                .some(data => data.numero_documento == this.personasService.findDocumentoFirst(this.personaEncontradaTemp.personaInfo?.documentos!)?.documento ||
                data.idProyectoProfesional==parseInt(this.profesionalSeleccionado?.id!));
            if (existeProfesional) {
                this.messageService.add({
                    severity: 'error', summary: '',
                    detail: 'Ya existe profesional asignado con el tipo seleccionado',
                });
            } else {
                this.datosProfesionales.push(perfilProfesional);
                this.profesionalSeleccionado = null;
                this.limpiarBusquedaPersona = true;
                this.botonAgregarProfesional = true;
                this.personasService.limpiarSeleccion();
                this.messageService.add({
                    severity: 'success', summary: '',
                    detail: 'Profesional agregado'
                });
                this.dtProfesionales.reset();
            }
        } else {
            this.errorProfesional = true
        }
    }

    eliminarLote(index: number, lote: LoteInterface) {
        if(lote !=null){
            this.updateEstadoLotes(lote);
        }
        this.datosLotes.splice(index, 1);
        this.dtLotes.reset();
    }

    eliminarProfesional(index: number) {
        this.datosProfesionales.splice(index, 1);
        this.dtProfesionales.reset();
    }

    eliminarDetConstruccion(index: number, item: DetalleConstruccionInterface) {
        this.datosDetallesConstruccion.splice(index, 1);
        this.dtDetalleConstruccion.reset();

        if(item != null){
            this.updateEstadoDetallesContruccion(item);
        }
    }


    //TODO: Reescribir validaciones de este metodo, evaluar si es posible procesar en el backend. 28NOV2024
    completarTramite() {
        if (this.isLoading()) return;
        this.isLoading.set(true);
        this.obtenerSdetItemTramites();

    }
    /**
     * <h4>Obtener informacion tramite</h4>
     * <p>Este metodo obtiene la informacion actualizada del proyecto vinculado al tramite</p>
     * <ul>
     *     <li>se detecto que las estaditisticas para los requisitos de tipo form, text en la respuesta no obtiene los datos actualizados cuando se completan
     *     de ultimo estos requisitos.</li>
     *     <li>este metodo al darle click al boton finalizar obtiene la información del proyecto o solictud vinculado al tramite,
     *     para obtener la informacion completa y actualizada cuando el usuario finalice el tramite</li>
     *     <li>el trámite para ser completado con exito debe cumplir con la informacion y todos los requisitos obligatorios.</li>
     *     <li>si el trámite ya cuenta con informacion y los requitos obligatorios completos se procesa y finaliza el trámite.</li>
     * </ul>
     * @since 13/01/2025
     */
    obtenerSdetItemTramites(){
        this.sdetTramiteService.obtenerSdetItem(this.tramiteService.idProyecto()!, this.idTramite!)
            .subscribe(
                {
                    next: (resp) => {
                        if (resp) {
                            this.selected = resp.body!
                            this.procesarTramite();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.isLoading.set(false);
                    },
                    complete: () => {
                        this.isLoading.set(false);
                    }
                }
            )
    }
    //TODO: Reescribir validaciones de este metodo, evaluar si es posible procesar en el backend. 28NOV2024
    procesarTramite(){
        if (this.esConstruccion()) {
            this.tramiteCompleto = false;
            if (!this.tipoInmuebleSeleccionado && !this.formCompletado()) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor seleccionar el tipo de inmueble.'
                });
                return;
            }
            if (this.tipoInmuebleSeleccionado?.id != '1' && !this.formCompletado()) {
                if (this.tipoInmuebleInput == "" || this.tipoInmuebleInput == null) {
                    this.messageService.add({
                        severity: 'error',
                        summary: '',
                        detail: 'Favor ingresar tipo de inmueble.'
                    });
                    return;
                }
            }
            if (!this.nivelSeleccionado && !this.formCompletado()) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor seleccionar el nivel.'
                });
                return;
            }
            if (this.cantidadUnidades == null && !this.formCompletado()) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor ingresar la cantida de unidades.'
                });
                return;
            }
            if (this.datosDetallesConstruccion.length == 0 && !this.formCompletado()) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor agregar los detalle de construccion son requeridos para el tramite del proyecto.'
                });
                return;
            }
            if (this.datosProfesionales.length == 0 && !this.formCompletado()) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor agregar los profesionales son requeridos para el tramite del proyecto.'
                });
                return;
            }
        }
        if (!this.esConstruccion()) {
            this.tramiteCompleto = false;
            if (this.cantidadLotes == null || this.cantidadLotes == 0) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor ingresar la cantida de lotes.'
                });
                return;
            }
            if (!this.tipoLoteSeleccionado) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor seleccionar el tipo de lote.'
                });
                return;
            }
            if (this.datosLotes.length == 0) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor agregar los lote son requeridos para el tramite del proyecto.'
                });
                return;
            }
        }

        if (this.selected && this.selected.idTramite!==undefined) {
            if (!(this.selected.qtycumplidos === this.selected.qtyrequeridos)) {
                Swal.fire({
                    icon: "warning",
                    title: "Error",
                    text: "Favor debe cargar los archivos y documentos requeridos",
                    showDenyButton: true,
                    showConfirmButton: false,
                    denyButtonText: `Ok`
                }).then(r => console.log('Favor debe cargar los archivos y documentos requeridos'));
                return;
            }

            if (this.selected.idEstadoTramite !== EstadoTramiteEnum.NoRequierePago && (!this.tarifa)) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor calcular la tarifa del trámite'
                });
                return;
            }
        }
        //Procesar los datos segun el tipo de flujo
        this.validacionPrimerFlujoCompletarTramite();
        this.tramiteCompleto = true
    }

    validacionPrimerFlujoCompletarTramite() {
        this._showLoader = true;
        if (this.esConstruccion()) {
            /**Proceso cuando es tipo contruccion**/
            if(this.selected && this.selected.idTramite!==undefined){
                this.obtenerDetallesConstruccion(this.datosDetallesConstruccion);
                this.obtenerProfesionalesDet(this.datosProfesionales);
                this.completeFormProcess(this.selected)
            } else{
                //proceso cuando retorna vacio this.selected de la api sdet es porque el tramite no tiene requisitos
                this.obtenerDetallesConstruccion(this.datosDetallesConstruccion);
                this.obtenerProfesionalesDet(this.datosProfesionales);
                const id = parseInt(this.tramiteService.idProyecto()!) ? parseInt(this.tramiteService.idProyecto()!) : 0;
                this.router.navigate(['/users/pagos/tramites', id])
                    .then(() => {
                        console.log(`tramites si requisitos done` + JSON.stringify(this.route.snapshot.queryParams))
                    });
            }

        } else {
            /**Proceso cuando no es tipo contruccion**/
            if(this.selected && this.selected.idTramite!==undefined){
                this.obtenerLotesProyecto(this.datosLotes);
                this.completeFormProcess(this.selected)
            } else{
                //proceso cuando retorna vacio this.selected de la api sdet es porque el tramite no tiene requisitos
                this.obtenerLotesProyecto(this.datosLotes);
                const id = parseInt(this.tramiteService.idProyecto()!) ? parseInt(this.tramiteService.idProyecto()!) : 0;
                this.router.navigate(['/users/pagos/tramites', id])
                    .then(() => {
                        console.log(`tramites si requisitos done` + JSON.stringify(this.route.snapshot.queryParams))
                    });
            }
        }
    }

    /**
     * Metodo que almacena los lotes del formulario al completar formulario en caso de que existe el servidor actualiza los datos
     */
    obtenerLotesProyecto(datosLotes: LoteInterface[]) {
        console.log("obtenerLotesProyecto")
        if (this.datosLotes.length > 0) {
            this.tramiteService.procesarLotes(datosLotes, parseInt(this.tramiteService.idProyecto()!)).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            console.log(`datos procesados lotes -> ${result}`);
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar los lotes'
                        });
                    },
                    complete: () => {
                    }
                }
            )
        }
    }

    obtenerDetallesConstruccion(datosDetalleConstruccion: DetalleConstruccionInterface[]) {
        console.log("obtenerDetallesConstruccion")
        if (this.datosDetallesConstruccion.length > 0) {
            this.tramiteService.procesarDetallesConstruccion(datosDetalleConstruccion, parseInt(this.tramiteService.idProyecto()!)).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            console.log(`datos procesados detalle construccion -> ${result}`);
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar los detalle construccion'
                        });
                    },
                    complete: () => {
                    }
                }
            )
        }
    }

    /**
     * Metodo que almacena los profesionales del formulario
     */
    obtenerProfesionalesDet(datosProyectoProfesionalesDet: ProfesionalesTablaInterface[]) {
        console.log("obtenerProfesionalesDet")
        if (this.datosProfesionales.length > 0) {
            this.tramiteService.procesarProyectoProfesionalesDet(datosProyectoProfesionalesDet, parseInt(this.tramiteService.idProyecto()!)).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            console.log(`datos procesados proyecto profesionales det -> ${result}`);
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar los profesionales'
                        });
                    },
                    complete: () => {
                    }
                }
            )
        }
    }

    /**
     *Metodo que limpia los datos de busqueda cuando se presiona la teclas ESC
     */
    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            this.personasService.limpiarSeleccion();
        }
    }

    /**
     *Metodo que limpia los datos de busqueda de la persona
     *cuando se de click en el boton cerrar del dialog
     */
    cerrarDialog(): void {
        this.personasService.limpiarSeleccion();
    }
    onChangeArea(event: any,area: number) {
        console.log("Areaaaaaaaaaaa ------->", area);
        if(area === null || area === undefined || area === 0)return;
        if (event.key === '.' || event.key === ' ') {
            event.preventDefault();
        }
        const areaActiva = this.areaActiva();
        if (area != null && this.tramiteService.idProyecto() != null) {
            //Aqui se podria agregar una condicion para mostrar si es de construccion y hacer el calculo desde aqui
            const idTipoArea = this.getTipoArea(this.esConstruccion() ? TipoAreaEnum.Areaconstruccion! : TipoAreaEnum.Areaproyecto);

            const areasRegisto: AreaChanged = {
                // idTipoArea: this.getTipoArea(TipoAreaEnum.Areaproyecto!),
                idTipoArea: idTipoArea,
                idProyecto: this.tramiteService.idProyecto()!=null ? parseInt(this.tramiteService.idProyecto()!) : 0,
                area: area,
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario!
            };

            console.log("Areas Registro -------->", {areasRegisto});

            this.formularioAService.actualizarAreas(areasRegisto).pipe(
                debounceTime(200), // Debounce for 200 milliseconds
                distinctUntilChanged(), // Only proceed if the query has changed
            ).subscribe({
                next: (result) => {
                    if (result) {
                        this._showLoader = false;
                        //obtener areas con la actualizacion
                        setTimeout(() => {
                            this.getInfoAreaProyecto(this.tramiteService.idProyecto()!, this.calculoAreaConstruccion, "tipoareas");
                            setTimeout(() => this.onChangeCalcularTarifa(), 300);
                        }, 200);
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
        }
        if (area==0 && areaActiva==0) {
            Swal.fire({
                icon: 'error',
                title: 'Area Invalida',
                text: 'El Área debe ser mayor que cero.',
                confirmButtonAriaLabel: 'Ok'
            })
            this.tarifa = 0;
            return;
        }
        if (area==null && areaActiva==null) {
            this.tarifa = 0;
            return;
        }
        if(areaActiva==0){
            this.tarifa = 0;
            return;
        }
        if (area==null) {
            Swal.fire({
                icon: 'error',
                title: 'Area Invalida',
                text: 'El Área no debe ser nula.',
                confirmButtonAriaLabel: 'Ok'
            })
            this.tarifa = 0;
            return;
        }
    }

    isNumericValid(event: KeyboardEvent) {
        if (event.key) {
            isAlphaNumericValidEvent(event, 2);
        }
    }

    isCharactersValid(event: KeyboardEvent) {
        if (event.key) {
            isAlphaNumericValidEvent(event, 3);
        }
    }

    /**
     Este metodo verifica si el id de un proyecto existe antes de finalizar el tramite
     y tambien hace un update cuando se agrega un nuevo proyecto de tipo flujo 2
     */
    validacionBotonCompletarTramite(): boolean {
        return this.tramiteService.idProyecto() == null;
    }

    setPesonaSelectedEffect = effect(() => {
        if (this.personasService.selected() != null) {
            this.personaEncontradaTemp.personaInfo = this.personasService.selected();
            this.botonAgregarProfesional = true;
        } else {
            this.botonAgregarProfesional = false;
        }
    }, {allowSignalWrites: true})

    esConstruccionEffect = effect(() => {
        if (this.esConstruccion() != null) {
            if (this.esConstruccion()) {
                this.catalogoService.getCatalogo('proyecto_profesionales')
                    .subscribe(
                        resp => {
                            this.profesionales = resp
                        }
                    )
            }
        }
    })

    /**Metodo que permite hacer el calculo de la tarifa de forma automatica siempre y cuando la tarifa no este vacia*/
    areaTotalEffect = effect(() => {
        const area = this.areaActiva();
        const proyecto = this.tramiteService.proyectoAsignado()[0];

        if(area !== 0 && area !== null && proyecto?.idEntorno !== undefined && this.tramiteService.tiposAreas().length > 0){
            setTimeout(() => {
                this.onChangeCalcularTarifa();
            }, 400);
        }else{
            this.tarifa = 0;
        }
        // if ((this.tramiteService.areaTotalSignal() !== 0 && this.tramiteService.areaTotalSignal() !== null) &&
        //     (this.tramiteService.proyectoAsignado().length > 0 &&
        //         this.tramiteService.proyectoAsignado()[0]?.idEntorno !== undefined &&
        //         this.tramiteService.tiposAreas().length > 0)) {
        //     setTimeout(() => {
        //         this.onChangeCalcularTarifa();
        //     }, 400);
        // }
    }, {allowSignalWrites: true});

    getAreaByTipo(tipo: TipoAreaEnum) {
        return this.tramiteService.tiposAreas().find(area => area.idTipoArea === tipo)?.area!;
    }
    getTipoArea(tipo: TipoAreaEnum) {
        return this.tramiteService.tiposAreas().find(area => area.idTipoArea === tipo)?.idTipoArea!;
    }
    goBack(): void {
        this.location.back();
    }
    onReceiveTramite(selected: TramiteItem): void {
        this.selected = selected;
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
        console.log('Page refresh detected');
        this.tramiteService.idProyecto.set(null)
        this.tramiteService.resetStatus()
    }

    private completeFormProcess(selected: TramiteItem) {
        this.tramiteService.completeFormProcess(selected)
            .pipe(
                tap(_ => console.log('SDet actualizado correctamente')),
                debounceTime(1000), // Debounce for 1000 milliseconds = 1 sec                            distinctUntilChanged(), // Only proceed if the query has changed
                switchMap(query => this.tramiteService.completeFormProcess(selected)),
                catchError(error => {
                    return throwError(() => error);
                })
            ).subscribe(
            resp => {
                if (resp.status == 200 || resp.status == 201) {
                    this._showLoader = false;
                    const id = selected.idProyecto ? selected.idProyecto : 0;
                    this.router.navigate(['/users/pagos/tramites', id])
                        .then(() => {
                            console.log(`tramites done` + JSON.stringify(this.route.snapshot.queryParams))
                        });
                }
            }
        )
    }
    /**
     * Metodo que almacena los datos lotes que se van agregando y calcula tarifa en dato caso si se asigna un tramite al formulario b y requiere datos de lotes se realizara el calculo
     */
    guardarLotesProyecto(datosLotes: LoteInterface[]) {
        console.log("guardarLotesProyecto")
        if (this.datosLotes.length > 0) {
            this.tramiteService.procesarLotes(datosLotes, parseInt(this.tramiteService.idProyecto()!)).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            this.onChangeCalcularTarifa();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar los lotes'
                        });
                    },
                    complete: () => {
                    }
                }
            )
        }
    }

    /**
     * Metodo que actualiza estado de lotes cuando se remueven
     */
    updateEstadoLotes(datosLotes: LoteInterface) {
        console.log("updateEstadoLotes")
        if (datosLotes !== null) {
            this.tramiteService.updateEstadoLotes(datosLotes).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            this.onChangeCalcularTarifa();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    },
                    complete: () => {
                    }
                }
            );
        }
    }
    /**
     * Metodo para almacenar unidades habitacionales y calcular tarifa de ser necesario si el tramite requiere calculo por casa, depto o local */
    guardarDetallesContruccion(datosDetalleConstruccion: DetalleConstruccionInterface[]) {
        console.log("guardarDetallesContruccion")
        if (datosDetalleConstruccion.length > 0) {
            this.tramiteService.procesarDetallesConstruccion(datosDetalleConstruccion, parseInt(this.tramiteService.idProyecto()!)).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            this.onChangeCalcularTarifa();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar los detalle construccion'
                        });
                    },
                    complete: () => {
                    }
                }
            )
        }
    }
    /**
     * Este metodo actualiza el estado de los detalle construccion cuando se remueven*/
    updateEstadoDetallesContruccion(detalleConstruccionInterface: DetalleConstruccionInterface) {
        console.log("updateEstadoDetallesContruccion")
        if (detalleConstruccionInterface !== null) {
            this.tramiteService.updateEstadoDetalleUnidades(detalleConstruccionInterface).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            this.onChangeCalcularTarifa();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    },
                    complete: () => {
                    }
                }
            );
        }
    }

    prjDetConst = computed(() => {
            if (this.tramiteService.proyectoAsignado()) {
                return this.tramiteService.proyectoAsignado()[0];
            } else {
                return null;
            }
        }
    );

    ngOnDestroy(): void {
        console.log(`formulario-b ngOnDestroy()->` + this.constructor.name)
        this.tramiteService.areaTotalSignal.set(0);
        this.tramiteService.tiposAreas.set([])
        this.tramiteService.proyectoAsignado.set([]);
    }
}
